// extracted by mini-css-extract-plugin
export const collection = "article-module--collection--3KQrj";
export const leading = "article-module--leading--2pBIz";
export const place = "article-module--place--1cRhT";
export const content = "article-module--content--3zBea";
export const typography = "article-module--typography--3R-O7";
export const gatsbyRespImageWrapper = "article-module--gatsby-resp-image-wrapper--3MINc";